/**
*
*   Content Block
*       - A left/right content block + image or video
*
**/
'use client';

import Config from '@/config';
import Button from '@/components/button';
import { ModalContext } from '@/context/modal';
import { useContext } from 'react';
import { useTranslations } from 'next-intl';

//Build the Element
export default function AllIngredients({ product, ...props }){

    //Modal Context
    const { Modal } = useContext(ModalContext);

    //Translations
    const t = useTranslations();

    //If no ingredients, skip this step
    if( !product.ingredients ) return;

    //Return
    return (
        <Button onClick={
            () => Modal.open({
                ingredients: {
                    product: product
                }
            })
        } type="small" inverted>
            { t('Pages.Product.buttons.all-ingredients') }
        </Button>
    );

}